<template>
    <div class="outlet-form">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12">
  
            <b-card>
              <div slot="header">
                {{$t('client.config')}}
              </div>
              <b-form class="row">
                <b-col cols="12">
  
                  <b-form-group v-for="(option, i) in category.list" :key="i+0" v-bind:label="option.name" :label-cols="4" :horizontal="true">
                    <b-row>
                      <b-col cols="6">
                        <b-form-group v-bind:label="$t('client.display')" label-cols="3" :horizontal="true">
                          <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                    :pill="true" v-model="category.list[i].show" :value="true" :uncheckedValue="false"/>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6" v-if="!without_disable.includes(option.type)">
                        <b-form-group v-bind:label="$t('client.disable')" label-cols="3" :horizontal="true">
                          <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                    :pill="true" v-model="category.list[i].disable" :value="true" :uncheckedValue="false"/>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-form>
            </b-card>
            <b-card>
              <div slot="header">
                {{$t('client.customization')}}
              </div>
              <b-form class="row">
                <b-col cols="12">
                  <customization v-model="category.fields" :position_fields="position_fields"></customization>
                </b-col>
              </b-form>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </template>
  
  <script>
  import cSwitch from '../../../components/Switch'
  import Customization from './Customization'
  export default {
    name: 'CategoryForm',
    props: {
      value: {
        type: Object
      }
    },
    components: {
      Customization,
      cSwitch
    },
    data: function () {
      return {
        without_disable: [
          'seo_configuration'
        ],
        position_fields: [
          'name_seo',
          'level'
        ],
        category: {
          basic_info: [],
          fields: [],
          config: {},
          list: [
            {
              'disable': false,
              'name': 'Ranking by category',
              'type': 'membership_id',
              'show': false
            },
            {
              'disable': false,
              'name': 'SEO Configuration',
              'type': 'seo_configuration',
              'show': false
            }
          ]
        },
        category_config : {}
      }
    },
    methods: {
      updateData () {
        // Update Base Info
        if (this.value != null && this.value.basic_info != null) {
          let basicInfo = {}
          for (let i in this.value.basic_info) {
            basicInfo[this.value.basic_info[i].type] = {
              show: this.value.basic_info[i].show,
              disable: this.value.basic_info[i].disable
            }
          }
          for (let i in this.category.basic_info) {
            if (basicInfo[this.category.basic_info[i].type] != null) {
              this.category.basic_info[i].show = basicInfo[this.category.basic_info[i].type].show
              this.category.basic_info[i].disable = basicInfo[this.category.basic_info[i].type].disable
            }
          }
        }
        // Update List Info
        if (this.value != null && this.value.list != null) {
          let basicInfo = {}
          for (let i in this.value.list) {
            basicInfo[this.value.list[i].type] = {
              show: this.value.list[i].show,
              disable: this.value.list[i].disable
            }
          }
          for (let i in this.category.list) {
            if (basicInfo[this.category.list[i].type] != null) {
              this.category.list[i].show = basicInfo[this.category.list[i].type].show
              this.category.list[i].disable = basicInfo[this.category.list[i].type].disable
            }
          }
        }
        // Update Config
        if (this.value != null && this.value.config != null) {
          for (let i in this.category.config) {
            if (this.value.config[i] != null) {
              this.category.config[i] = this.value.config[i]
            }
          }
        }
        // Update customization field
        if (this.value != null && this.value.fields != null) {
          this.category.fields = this.value.fields
        }
      }
    },
    created: function () {
    },
    mounted: function () {
      this.updateData()
    },
    watch: {
      category: {
        handler: function (newValue) {
          this.$emit('input', this.category)
          this.$emit('change', this.category)
        },
        deep: true
      },
      value: {
        handler: function (newValue) {
          this.updateData()
        },
        deep: true
      }
    }
  }
  </script>
  
  <style scoped>
  </style>


// WEBPACK FOOTER //
// src/views/admin/client/CategoryForm.vue